

















import { defineComponent, onUnmounted, ref } from "@vue/composition-api"
import { useFindOneBooking } from "@/app/reactive/booking"
import Title from "@/app/components/common/Title.vue"
import Subtitle from "@/app/components/common/Subtitle.vue"
import Content from "@/app/components/common/Content.vue"
import Hint from "@/app/components/common/Hint.vue"
import BookingGateControls from "./BookingGateControls.vue"
import { FacilityModel } from "@/app/models/facility.model"
import BookingDetailInfoBox from "@/app/components/booking/BookingDetailInfoBox.vue"
import { Settings, DateTime } from "luxon"

export default defineComponent({
  name: "BookingRecentlyPaid",
  components: {
    Title,
    Subtitle,
    Content,
    Hint,
    BookingGateControls,
    BookingDetailInfoBox,
  },
  props: {
    facility: {
      type: Object as () => FacilityModel,
      required: true,
    },
  },
  setup() {
    const { booking } = useFindOneBooking()
    const displayGateController = ref(false)
    const minutesMax = ref(20)
    const minutesLeft = ref(20)
    const intervalNumber = ref(-1)
    Settings.defaultLocale = "de"

    // Check booking time on load and setup countdown interval
    checkBookingTime()
    setupCountdownInterval()

    function checkBookingTime() {
      if (booking.value && booking.value.paidAt) {
        if (
          DateTime.fromJSDate(booking.value.paidAt).diffNow("seconds").seconds <
          0
        ) {
          const minutesPassed = DateTime.fromJSDate(
            booking.value.paidAt,
          ).diffNow("minutes").minutes
          minutesLeft.value = Math.round(minutesMax.value + minutesPassed)
          displayGateController.value = true
        }
      }

      if (minutesLeft.value <= 0 && displayGateController.value) {
        displayGateController.value = false
      }
    }

    function setupCountdownInterval() {
      intervalNumber.value = setInterval(() => {
        checkBookingTime()
      }, 1000 * 1)
    }

    onUnmounted(() => {
      // Clear the interval when the component gets unmounted
      clearInterval(intervalNumber.value)
    })

    return {
      booking,
      stop,
      minutesLeft,
      displayGateController,
    }
  },
})
